import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { catchError, firstValueFrom } from 'rxjs';
import { ErrorFrontend } from '@core/errors';
import type { BranchListItem, PaginatedResponse, PaginationParams } from '@core/models';

/**
 * Branch Service — scope-filtered reference data
 * (filter options, acting-branch selection).
 */
@Injectable({
  providedIn: 'root',
})
export class BranchService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = 'orgs/branches';

  /** Branches in the caller's scope. */
  async list(params?: PaginationParams): Promise<PaginatedResponse<BranchListItem>> {
    return await firstValueFrom(
      this.http
        .get<PaginatedResponse<BranchListItem>>(`${this.baseUrl}/`, {
          params: params as Record<string, string | number>,
        })
        .pipe(
          catchError((error: HttpErrorResponse) => {
            throw new ErrorFrontend(error);
          }),
        ),
    );
  }
}
